import api from "./api";

// Receipt validation runs OCR on the bot, same as the settlement page.
const RECEIPT_TIMEOUT_MS = 150000;
const UPLOAD_TIMEOUT_MS = 60000;

function unwrap(data, fallbackMessage) {
  if (data?.isSuccessful === false) {
    const errorMessage =
      data.getMessageText?.filter(Boolean).join("، ") || data.message?.[0]?.messageText || fallbackMessage;
    throw new Error(errorMessage);
  }
  return data?.data ?? data;
}

function toError(error, fallbackMessage) {
  if (error?.response?.data) {
    try {
      unwrap(error.response.data, fallbackMessage);
    } catch (wrapped) {
      return wrapped;
    }
  }
  if (error?.code === "ECONNABORTED") return new Error("پاسخی از سرور دریافت نشد. لطفاً دوباره تلاش کنید.");
  return error instanceof Error && error.message ? error : new Error(fallbackMessage);
}

async function call(request, fallbackMessage) {
  try {
    const { data } = await request();
    return unwrap(data, fallbackMessage);
  } catch (error) {
    throw toError(error, fallbackMessage);
  }
}

// FormData bypasses the axios digit normalizer, so chat text stays exactly as typed.
function form(fields) {
  const body = new FormData();
  Object.entries(fields).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    body.append(key, value);
  });
  return body;
}

export const getConversations = () =>
  call(() => api.get("/Trading/Chat/Conversations"), "دریافت گفتگوها ناموفق بود");

export const getUnread = () => call(() => api.get("/Trading/Chat/Unread"), "دریافت پیام‌های جدید ناموفق بود");

export const getMessages = ({ conversationId, afterId, beforeId, take }) =>
  call(
    () => api.get("/Trading/Chat/Messages", { params: { conversationId, afterId, beforeId, take } }),
    "دریافت پیام‌ها ناموفق بود"
  );

export const sendText = ({ conversationId, text, clientMessageId }) =>
  call(
    () => api.post("/Trading/Chat/Messages/Text", form({ ConversationId: conversationId, Text: text, ClientMessageId: clientMessageId })),
    "ارسال پیام ناموفق بود"
  );

export const sendMedia = ({ conversationId, file, kind, durationSeconds, caption, clientMessageId }) =>
  call(
    () =>
      api.post(
        "/Trading/Chat/Messages/Media",
        form({
          ConversationId: conversationId,
          File: file,
          Kind: kind,
          DurationSeconds: durationSeconds,
          Caption: caption,
          ClientMessageId: clientMessageId,
        }),
        { timeout: UPLOAD_TIMEOUT_MS }
      ),
    kind === "voice" ? "ارسال پیام صوتی ناموفق بود" : "ارسال تصویر ناموفق بود"
  );

export const markRead = ({ conversationId, lastMessageId }) =>
  call(() => api.post("/Trading/Chat/Read", { conversationId, lastMessageId }), "به‌روزرسانی وضعیت خواندن ناموفق بود");

/** Downloads a message file with the auth header; callers turn it into an object URL. */
export async function getMessageFile(messageId) {
  try {
    const { data } = await api.get(`/Trading/Chat/Files/${messageId}`, { responseType: "blob" });
    return data;
  } catch (error) {
    throw toError(error, "دریافت فایل ناموفق بود");
  }
}

export const submitChatReceipt = ({ conversationId, sendLogId, receiptImage, token, confirmAmount, amountRial }) =>
  call(
    () =>
      api.post(
        "/Trading/Chat/Receipts/Submit",
        form({
          ConversationId: conversationId,
          SendLogId: sendLogId,
          ReceiptImage: receiptImage,
          Token: token,
          ConfirmAmount: confirmAmount ? "true" : "false",
          AmountRial: amountRial,
        }),
        { timeout: RECEIPT_TIMEOUT_MS }
      ),
    "ارسال فیش ناموفق بود"
  );
